// ===================================================================
// 🎯 COMPONENTE DE HEADER
// ===================================================================

import React, { useState, useEffect, useCallback } from 'react';
import { styles } from '../../styles/globalStyles';
import { NotificationBell } from '../ui/NotificationBell';
import { apiClient } from '../../api/apiClient';
import { useCandidateMobileLayout } from '../../hooks/useCandidateMobileLayout';

export const Header = React.memo(({ user, onLogout, onOpenProfile, profileButtonLabel = 'Meus dados', onOpenAbout, aboutActive = false }) => {
  const [systemName, setSystemName] = useState('Ingressa');
  const [icon, setIcon] = useState('');
  const isCandidateMobile = useCandidateMobileLayout() && (user?.role === 'candidate' || !user?.role);

  useEffect(() => {
    apiClient.getConfig()
      .then((data) => {
        setSystemName(data.system_name || 'Ingressa');
        setIcon(data.institution_icon || '');
      })
      .catch(() => {});
  }, []);

  const handleLogout = useCallback(() => {
    onLogout();
  }, [onLogout]);

  const compactProfileLabel = isCandidateMobile ? 'Perfil' : profileButtonLabel;
  const compactLogoutLabel = isCandidateMobile ? 'Sair' : '🚪 Sair';
  const showAbout = typeof onOpenAbout === 'function';

  return (
    <header style={styles.header} className="ingressa-app-header">
      <nav
        style={styles.nav}
        className={`ingressa-header-nav${isCandidateMobile ? ' ingressa-header-nav-compact' : ''}`}
      >
        <div style={styles.logoSection} className="ingressa-logo-section">
          <div
            className="ingressa-logo"
            style={{
            ...styles.logo,
            backgroundColor: 'transparent',
            padding: 4
          }}>
            {(icon && (icon.startsWith('http') || icon.startsWith('/'))) ? (
              <img src={icon} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            ) : (
              <img src="/static/ingressa-logo.svg" alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            )}
          </div>
          <h1 style={styles.navTitle} className="ingressa-nav-title">{systemName}</h1>
        </div>
        
        <div style={styles.userSection} className="ingressa-header-user-section">
          {showAbout && (
            <button
              type="button"
              onClick={onOpenAbout}
              className="ingressa-header-btn ingressa-header-btn-about"
              title="Informações da empresa proprietária do sistema"
              aria-label="Sobre"
              aria-current={aboutActive ? 'page' : undefined}
              style={{
                ...styles.button,
                ...(aboutActive ? styles.buttonPrimary : styles.buttonSecondary),
                ...styles.buttonSmall,
                marginRight: isCandidateMobile ? 0 : '8px',
              }}
            >
              {isCandidateMobile ? 'ℹ️' : 'ℹ️ Sobre'}
            </button>
          )}
          <NotificationBell />
          {!isCandidateMobile && (
          <div className="ingressa-header-user-block">
            <div style={styles.userName} className="ingressa-user-name">{user.display_name || user.name}</div>
            <div style={styles.userRole} className="ingressa-user-role">
              {user.role === 'admin' ? 'Administrador' : 
               user.role === 'analyst' ? 'Analista' : 
               user.role === 'campus' ? 'Unidade' : 
               user.role === 'master' ? 'Proprietário' : 'Candidato'}
            </div>
          </div>
          )}
          {onOpenProfile && (
            <button
              type="button"
              onClick={onOpenProfile}
              className="ingressa-header-btn ingressa-header-btn-profile"
              style={{
                ...styles.button,
                ...styles.buttonSecondary,
                ...styles.buttonSmall,
                marginRight: isCandidateMobile ? 0 : '8px'
              }}
              aria-label={profileButtonLabel}
            >
              {compactProfileLabel}
            </button>
          )}
          <button
            onClick={handleLogout}
            className="ingressa-header-btn ingressa-header-btn-logout"
            style={{
              ...styles.button,
              ...styles.buttonSecondary,
              ...styles.buttonSmall
            }}
            aria-label="Sair do sistema"
          >
            {compactLogoutLabel}
          </button>
        </div>
      </nav>
    </header>
  );
});
